import React from "react";
import Heading from "./small-component/Heading";

const ContactCards = (props) => (
  <div className="card text-center mt-4">
    <i className={props.iconClass}></i>
    <h3>{props.h3}</h3>
    <p>{props.p}</p>
  </div>
);



export default function Contact() {
  return (
    <div>
      <section id="contact" className="section-bg">
        <div className="container">
          <Heading title="Contact us" />
          <p className="text-center"></p>
          <div className="">
            <div className="row">
              <div className="col-12 col-lg-6">
                <ContactCards
                  iconClass="icofont-google-map"
                  h3="Our Address"
                  p="Faridabad, Haryana, India"
                />
              </div>
              <div className="col-6 col-lg-3">
                <a href="mailto:aligatoritsolutions@gmail.com">
                  <ContactCards
                    iconClass="fa fa-envelope-o"
                    h3="Mail us"
                    p="aligatoritsolutions@gmail.com"
                  />
                </a>
              </div>
              <div className="col-6 col-lg-3">
                <a href="https://api.whatsapp.com/send?phone=+919354347667">
                  <ContactCards
                    iconClass="fa fa-whatsapp"
                    h3="WhatsApp us"
                    p="+(91) 9354347667"
                  />
                </a>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-lg-12 ">
                <div>
                  <iframe
                    title="Our Address"
                    className="mb-4 mb-lg-0"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d269035.08327511675!2d77.17572945622365!3d28.40649044687445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdc15f5a424b1%3A0xe4f50576c850e0f2!2sFaridabad%2C%20Haryana!5e0!3m2!1sen!2sin!4v1598882358281!5m2!1sen!2sin"
                    frameBorder="0"
                    style={{ border: 0, width: "100%", height: "384px" }}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
